export enum AppointmentHistoricalFieldsEnum {
	AppointmentTypeId = 'AppointmentTypeId',
	Status = 'Status'
}